import { UserCheck } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useGetApiCompaniesCurrentEmployeesReportingActivatedaccounts } from '@/api/generated/company-management-user/company-management-user'
import { StatisticsCard } from '../components/StatisticsCard'

export function ActivatedAccountsCard() {
  const { t } = useTranslation('dashboard')
  const { data, isLoading, isError } = useGetApiCompaniesCurrentEmployeesReportingActivatedaccounts()

  const accounts = data?.data
  const activationRate = accounts && accounts.total > 0
    ? Math.round((accounts.active / accounts.total) * 100)
    : null

  return (
    <StatisticsCard
      title={t('statistics.activatedAccounts.title')}
      value={accounts?.active ?? '—'}
      sub={activationRate != null ? t('statistics.activatedAccounts.activationRate', { rate: activationRate }) : undefined}
      CustomIcon={UserCheck}
      isLoading={isLoading}
      isError={isError}
    />
  )
}
